import type { ParteItem } from '@/types/costo';
import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  parte: ParteItem;
};

// Cada parte recibe solo su presupuesto: el adquiriente lo envía a los
// compradores y el transferente a los vendedores.
const DESTINATARIOS_POR_PARTE: Record<ParteItem, Array<'compradores' | 'vendedores'>> = {
  adquiriente: ['compradores'],
  transferente: ['vendedores'],
};

const WhatsAppPresupuestoModal = ({ open, onOpenChange, tramite, parte }: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      eventType="escrituras.envio_presupuesto"
      title={`Enviar presupuesto del ${parte} por WhatsApp`}
      description="Se enviará el presupuesto en PDF con enlace temporal seguro."
      contextOverrides={{ parte }}
      recipientGroups={DESTINATARIOS_POR_PARTE[parte]}
    />
  );
};

export default WhatsAppPresupuestoModal;
